import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
import React, { useRef } from 'react';
import { match } from 'ts-pattern';
import { range } from '../lib/Math';

type FadeDirection = 'top' | 'bottom';

export const ScrollFade = ({
  direction,
  interpolationPoint,
  spring,
  children,
}: {
  direction: FadeDirection;
  interpolationPoint: number;
  spring?: boolean;
  children: React.ReactNode;
}) => {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: match(direction)
      .with('top', () => ['end start' as const, 'start end' as const])
      .with('bottom', () => ['start end' as const, 'start start' as const])
      .exhaustive(),
  });

  const opacity = useTransform(scrollYProgress, (x) => {
    if (x <= interpolationPoint) {
      if (spring) {
        return 0;
      } else {
        return range(0, interpolationPoint, 0, 1, x);
      }
    } else {
      return 1.0;
    }
  });

  const opacitySpring = useSpring(opacity);

  return (
    <motion.div ref={ref} style={{ opacity: spring ? opacitySpring : opacity }}>
      {children}
    </motion.div>
  );
};
